import React, { useState } from 'react';
import { NavigationItem } from '../models';

interface MobileNavigationProps {
  navigationItems: NavigationItem[];
  isVisible: boolean;
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({
  navigationItems,
  isVisible
}) => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [expandedSecondaryIndex, setExpandedSecondaryIndex] = useState<number | null>(null);

  React.useEffect(() => {
    if (!isVisible) {
      setExpandedIndex(null);
      setExpandedSecondaryIndex(null);
    }
  }, [isVisible]);

  const handlePrimaryClick = (index: number) => {
    setExpandedIndex(index === expandedIndex ? null : index);
    setExpandedSecondaryIndex(null);
  };
  const handleSecondaryClick = (secIndex: number) => {
    setExpandedSecondaryIndex(secIndex === expandedSecondaryIndex ? null : secIndex);
  };


  const handlePrimaryNavClick = (item: NavigationItem) => {
    // If item has no secondary content, redirect
    if (!item.menuLinks?.length && !item.headernavigation?.secondaryLinks) {
      if (item.url) {
        window.open(item.url, item.target);
      }
    }
  };

  return (
    <div className={`sub-menu-mobile ge-header-wrap${isVisible ? '' : ' element-not-visible'}`}>
      <div className="sub-menu-container">
        <div className="ge-header-expansion-overlay-extraspace tablet"></div>
        <div className="menu-content-wrapper">
          <div className="mobile-menu-container">
            {expandedIndex === null ? (
              // Render all main menu items
              navigationItems.map((item, itemIndex) => {
                const hasMenuLinks = item.menuLinks?.length > 0;
                const secondaryLinksObj = item.headernavigation?.secondaryLinks;
                const hasHeaderNavigation = secondaryLinksObj && typeof secondaryLinksObj === 'object' && Object.keys(secondaryLinksObj).length > 0;
                const hasSecondaryItems = hasMenuLinks || hasHeaderNavigation;
                // Always render the first secondary link's icon if present, regardless of menuLinks
                let firstSecondaryIcon = null;
                if (secondaryLinksObj && typeof secondaryLinksObj === 'object') {
                  const keys = Object.keys(secondaryLinksObj);
                  let found = false;
                  for (let i = 0; i < keys.length; i++) {
                    const key = keys[i];
                    const link = secondaryLinksObj[key];
                    if (link && typeof link === 'object' && link.linkIcon) {
                      firstSecondaryIcon = (
                        <span
                          key={`secondary-icon-${itemIndex}-${key}`}
                          className="mobile-menu-container-item-data-icon"
                          style={{ marginLeft: 8, display: 'inline-flex', alignItems: 'center' }}
                          dangerouslySetInnerHTML={{ __html: link.linkIcon }}
                        />
                      );
                      found = true;
                      break;
                    }
                  }
                }
                return (
                  <div key={`mobile-nav-${item.title}-${itemIndex}`} className="mobile-menu-container-item-wraper">
                    <button
                      className="mobile-menu-container-item"
                      type="button"
                      aria-expanded={hasSecondaryItems ? expandedIndex === itemIndex : undefined}
                      aria-label={item.title}
                      onClick={(e) => {
                        e.preventDefault();
                        if (hasSecondaryItems) {
                          handlePrimaryClick(itemIndex);
                        } else {
                          handlePrimaryNavClick(item);
                        }
                      }}
                      style={{
                        cursor: 'pointer',
                        margin: 0,
                        padding: 0,
                        width: '100%',
                        textAlign: 'left',
                        display: 'flex',
                        alignItems: 'center',
                        background: 'none',
                        border: 'none',
                      }}
                    >
                      <p className='mobile-menu-container-item-data paragraph' style={{ margin: 0 }}>{item.title}</p>
                      {firstSecondaryIcon}
                    </button>
                  </div>
                );
              })
            ) : (
              // Render only the selected main menu item and its secondary items
              (() => {
                const item = navigationItems[expandedIndex];
                const hasHeaderNavigation = item.headernavigation?.secondaryLinks && Object.keys(item.headernavigation.secondaryLinks).length > 0;
                return (
                  <div key={`expanded-main-${item.title}-${expandedIndex}`} className="mobile-menu-container-item-wraper active">
                    <div className="mobile-menu-primary-item-expansion-label active">
                      {/* Caret left icon for active state */}
                      <button type="button" onClick={() => setExpandedIndex(null)} style={{ background: 'none', border: 'none'}} aria-label={`Back to main menu from ${item.title}`}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none">
                          <path d="M7.99779 14.248C7.99895 14.1496 7.98015 14.0521 7.9426 13.9617C7.90504 13.8713 7.84957 13.7901 7.77973 13.7231L1.76124 7.5L7.77973 1.27689C7.84926 1.20958 7.90468 1.12827 7.94257 1.038C7.98045 0.947735 8 0.850414 8 0.752049C8 0.653684 7.98045 0.556363 7.94257 0.466094C7.90468 0.375825 7.84926 0.294523 7.77973 0.227209C7.71447 0.155484 7.63565 0.0983182 7.54814 0.0592397C7.46063 0.0201612 7.36628 -3.34005e-07 7.27092 -3.29681e-07C7.17556 -3.25357e-07 7.08121 0.0201612 6.9937 0.0592397C6.90619 0.0983182 6.82737 0.155484 6.76211 0.227209L0.22027 6.97516C0.150736 7.04248 0.095316 7.12378 0.0574311 7.21405C0.0195462 7.30431 3.11898e-07 7.40164 3.16043e-07 7.5C3.20188e-07 7.59837 0.0195463 7.69569 0.0574311 7.78596C0.095316 7.87623 0.150736 7.95753 0.22027 8.02484L6.76211 14.7728C6.82737 14.8445 6.90619 14.9017 6.9937 14.9408C7.08121 14.9798 7.17556 15 7.27092 15C7.36628 15 7.46063 14.9798 7.54814 14.9408C7.63566 14.9017 7.71447 14.8445 7.77973 14.7728C7.84957 14.7058 7.90504 14.6246 7.9426 14.5342C7.98015 14.4438 7.99895 14.3463 7.99779 14.248Z" fill="#6022A6"></path>
                        </svg>
                      </button>
                      <span className="menu-label" style={{ marginLeft: '8px' }}>
                        {item.title}
                      </span>
                    </div>
                    <div className="mobile-menu-secondary-items">
                      {hasHeaderNavigation && Object.entries(item.headernavigation.secondaryLinks).map(([key, link]: [string, any], secIndex) => {
                        const hasTertiaryLinks = link.tertiaryLinks && Object.keys(link.tertiaryLinks).some((tertiaryKey: string) => tertiaryKey.startsWith('item'));
                        return (
                          link.linkText && <div key={`header-nav-${key}`} className="mobile-menu-secondary-item">
                            {hasTertiaryLinks ? (
                              <button
                                className="mobile-menu-secondary-item-label"
                                type="button"
                                aria-expanded={expandedSecondaryIndex === secIndex}
                                aria-label={link.linkText}
                                style={{ cursor: 'pointer', background: 'none', border: 'none', width: '100%', textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                onClick={() => handleSecondaryClick(secIndex)}
                              >
                                <span className="menu-label">{link.linkText}</span>
                                <span className="menu-icon">
                                  {expandedSecondaryIndex === secIndex
                                    ? (
                                        // Up arrow icon (expanded)
                                        item.upArrowIcon && (
                                          <span className="link-icon" dangerouslySetInnerHTML={{ __html: item.upArrowIcon }} />
                                        )
                                      )
                                    : (
                                        // Down arrow icon (collapsed)
                                        item.downArrowIcon && (
                                          <span className="link-icon" dangerouslySetInnerHTML={{ __html: item.downArrowIcon }} />
                                        ) 
                                      )
                                  }
                                </span>
                              </button>
                            ) : (
                              <button
                                className="mobile-menu-secondary-item-label"
                                type="button"
                                aria-label={link.linkText}
                                style={{ cursor: 'pointer', background: 'none', border: 'none', width: '100%', textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                onClick={() => {
                                  if (link.linkUrl) {
                                    window.open(link.linkUrl, link.target);
                                  }
                                }}
                              >
                                <span className="menu-label">{link.linkText}</span>
                              </button>
                            )}
                            {/* Tertiary links expansion */}
                            {hasTertiaryLinks && expandedSecondaryIndex === secIndex && (
                              <div className="mobile-menu-secondary-item-expansion">
                                <div className="mobile-menu-tertiary-items">
                                  {Object.entries(link.tertiaryLinks)
                                    .filter(([_, tertiaryLink]: [string, any]) => tertiaryLink.linkText && tertiaryLink.linkUrl)
                                    .map(([tertiaryKey, tertiaryLink]: [string, any]) => (
                                      <a
                                        key={`tertiary-${tertiaryKey}`}
                                        aria-label={tertiaryLink.linkText}
                                        href={tertiaryLink.linkUrl}
                                        target={tertiaryLink.target}
                                        className="menu-label"
                                      >
                                        {tertiaryLink.linkText}
                                      </a>
                                    ))}
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })()
            )}
          </div>
          <div className="mobile-menu-container-divider"></div>
        </div>
      </div>
    </div>
  );
};
export default MobileNavigation;